module.exports = "<div *ngIf=\"text\" class=\"textarea\" [innerHTML]=\"text | safeHtml\"></div>\n"